import { Component, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { EnvironmentInfoService } from 'src/app/core';
import { GridComponent } from '../grid.component';

export interface ClickableActionStockMovements<T = any> {
  action: 'details' | 'export' | 'generate-labels' | 'rollback' | 'goods-delivery';
  data: T;
  node: IRowNode<T>;
}

@Component({
  selector: 'app-grid-clickable-button-stock-movements',
  standalone: true,
  imports: [
    MatIcon,
    MatMenuModule,
    MatButtonModule,
    TranslateModule
  ],
  templateUrl: './grid-clickable-button-stock-movements.component.html',
  styleUrl: './grid-clickable-button-stock-movements.component.scss'
})
export class GridClickableButtonStockMovementsComponent implements ICellRendererAngularComp {

  private readonly environmentInfoService = inject(EnvironmentInfoService);

  params!: ICellRendererParams;

  protected canDownload = this.environmentInfoService.canDownloadFiles();
  protected showGoodsDelivery = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.showGoodsDelivery = params.data?.load_cause === 'supplier_order';
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  preventSelection($event: MouseEvent) {
    $event.stopPropagation();
  }

  emit(action: ClickableActionStockMovements['action']) {
    (<GridComponent>this.params.context.componentParent).clickableAction.emit({
      action,
      data: this.params.data,
      node: this.params.node
    });
  }
}
